import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import ExcelJS from 'exceljs'
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarExport, GridToolbarDensitySelector,} from "@mui/x-data-grid";
import { CloseOutlined } from "@mui/icons-material";
import { Dialog, DialogContent, Typography, IconButton, Button, Tooltip,} from "@mui/material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;
const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;
const StyledDialog = styled(Dialog)`
  position: relative;
`;
const DataGridContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  height: 400px;
`;
const NoteText = styled(Typography)`
  margin-top: 10px !important;
`;
const InputFieldContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap:10px;
  label{
    margin-bottom:0px;
  }
`;

const BulkUploadSpecimenByAdmin = ({ onClose, fetchData }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(true);
  const [targetRows, setTargetRows] = useState([]);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [uploaded, setUploaded] = useState(false);
  const [data, setData] = useState([]);
  const [view, setView] = useState(false);
  const fileInputRef = useRef(null);
  const [failedData, setFailedData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [fileKey, setFileKey] = useState(0);
  const [display, setDisplay] = useState(false);
  const [isloader, setIsloader] = React.useState(false);
  const [dataId, setDataId] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [seriesData, setSeriesData] = useState([])
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStats, setUploadStats] = useState(null);
  const [failedEntries, setFailedEntries] = useState([]);

  const getRowClassName = (params) => {
    let uploadStatus = params.row.status || "";
    if (uploadStatus === "Success") {
      return "successRow";
    } else if (uploadStatus === "Failure") {
      return "failureRow";
    } else {
      return "";
    }
  };
  useEffect(() => {
    fetchSeriesData()
  }, [])

  const fetchSeriesData = async () => {
    setLoading(true)
    try {
      const results = await window.Platform.database.getSeriesCategory();
      setSeriesData(results?.data)
      setLoading(false)
    }
    catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: 'bulk-upload-Supplier',
          }}
        />
      </GridToolbarContainer>
    );
  }

  const handleDownloadErrorReport = async () => {
    if (failedEntries.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Error Report');
    const headers = Object.keys(failedEntries[0]);
    worksheet.addRow(headers);
    failedEntries.forEach(entry => {
      worksheet.addRow(headers.map(header => entry[header]));
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Product_Error_Report.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedFile(file); // Store the selected file
    setFileKey((prevKey) => prevKey + 1);

    console.log(file, "Selected File:", file.name, file.type, file.size);
  };


  const handleUpload = async () => {
    if (!selectedFile) {
      window.NotificationUtils.showError("No file selected for upload.");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);

      console.log("Uploading File11:", selectedFile.name);


      let response = await window.Platform.database.uploadAllottedSpecimen(formData);
      // let response = await window.Platform.database.addProductBulk(formData);

      if (!response) {
        throw new Error("No response from server");
      }

      console.log("Upload Success:", response);


      const successCount = response?.results?.filter(entry => entry?.status === "Success").length;
      const failureEntries = response?.results?.filter(entry => entry?.status === "Failure");
      setUploadStats({ successCount, failureCount: failureEntries?.length, total: response?.results?.length });


      setFailedEntries(failureEntries);
      window.NotificationUtils.showSuccess("File uploaded successfully!");

      setSelectedFile(null);
    } catch (error) {
      console.error("Error uploading file:", error);
      window.NotificationUtils.showError("Error uploading file!");
    } finally {
      setLoading(false);
    }
  };



  const getGridColumns = () => {
    let columns = [
      {
        field: "id",
        headerName: "S.no",
        minWidth: 100,
        valueGetter: (params) => {
          let name = params.row.id || "";
          return name;
        },
        flex: 0.22,
        editable: false,
        renderCell: (params) => {
          let name = params.row.id || "";
          return (
            <Tooltip title={name}>
              <Typography variant="inherit">{name}</Typography>{console.log(params.row, "lllljjj")}
            </Tooltip>
          );
        },
      },
      {
        field: "SeriesName",
        headerName: "Series Name",
        minWidth: 150,
        valueGetter: (params) => {
          let name = params.row.SeriesName
          return name
        },
        flex: 0.22,
        editable: false,
        renderCell: (params) => {
          // console.log("RESPONSE",params)
          let name = params.row.SeriesName
          return (
            <Tooltip title={name}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "ProductName: ",
        headerName: "Product Name ",
        minWidth: 150,
        valueGetter: (params) => {
          let name = params.row.ProductName
          return name
        },
        flex: 0.22,
        editable: false,
        renderCell: (params) => {
          // console.log("RESPONSE",params)
          let name = params.row.ProductName
          return (
            <Tooltip title={name}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "UnitPrice",
        headerName: "UnitPrice",
        minWidth: 200,
        valueGetter: (params) => {
          let name = params.row.UnitPrice;
          return name;
        },
        renderCell: (params) => {
          // console.log("RESPONSE",params)
          let name = params.row.UnitPrice
          return (
            <Tooltip title={name}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          );
        }
      },
      {
        field: "Board",
        headerName: "Board",
        editable: false,
        hide: true,
        minWidth: 200,
        valueGetter: (params) => {
          let name = params.row.Board
          return name;


        },
        renderCell: (params) => {
          // console.log("RESPONSE",params)
          let name = params.row.Board
          return (
            <Tooltip title={name}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          );

        },
      },
      {
        field: "Medium",
        headerName: "Medium",
        editable: false,
        hide: true,
        minWidth: 200,
        valueGetter: (params) => {
          let name = params.row.Medium
          return name;


        },
        renderCell: (params) => {
          // console.log("RESPONSE",params)
          let name = params.row.Medium
          return (
            <Tooltip title={name}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          );

        },
      },
      {
        field: "Class",
        headerName: "Class",
        editable: false,
        hide: true,
        minWidth: 200,
        valueGetter: (params) => {
          let name = params.row.Class
          return name;


        },
        renderCell: (params) => {
          // console.log("RESPONSE",params)
          let name = params.row.Class
          return (
            <Tooltip title={name}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          );

        },
      },
      {
        field: "Subject",
        headerName: "Subject",
        editable: false,
        hide: true,
        minWidth: 200,
        valueGetter: (params) => {
          let name = params.row.Subject
          return name;


        },
        renderCell: (params) => {
          // console.log("RESPONSE",params)
          let name = params.row.Subject
          return (
            <Tooltip title={name}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          );

        },
      },
      {
        field: "skuCode",
        headerName: "skuCode",
        minWidth: 200,
        valueGetter: (params) => {
          let name = params.row.skuCode;
          return name;
        },
        renderCell: (params) => {
          // console.log("RESPONSE",params)
          let name = params.row.skuCode
          return (
            <Tooltip title={name}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          );

        },
      },
      {
        field: "Type",
        headerName: "Type",
        minWidth: 200,
        valueGetter: (params) => {
          let name = params.row.Type;
          return name;
        },
        renderCell: (params) => {
          // console.log("RESPONSE",params)
          let name = params.row.Type
          return (
            <Tooltip title={name}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          );

        },
      },

    ];
    if (uploaded) {
      columns.splice(
        0,
        0,
        {
          field: "status",
          headerName: "Upload Status",
          width: 100,
          renderCell: (params) => {
            // console.log("PARAMSINDATA",params)
            let name = "";
            if (params.row.status) {
              name =
                params.row.status === "Success" ? "Success" : "Failure";
            }
            return (
              <Tooltip title={name}>
                <Typography variant="inherit">{name}</Typography>
              </Tooltip>
            );
          },
          editable: false,
        },
        {
          field: "reason",
          headerName: "Reason",
          width: 200,
          renderCell: (params) => {
            let name = params.row.reason || "";
            return (
              <Tooltip title={name}>
                <Typography variant="inherit">{name}</Typography>
              </Tooltip>
            );
          },
          editable: false,
        }
      );
    }
    return columns;
  }

  const handleDownload = async () => {
    try {
      setLoading(true)
      const selectedColumns = ['ARM', 'RM', 'Emp ID', 'Area', 'SeriesName', 'ProductName', 'Type', 'Subject', "skuCode", "Quantity Allotted"]

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet1');
      worksheet.addRow(selectedColumns);
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Bulk_Specimen_Product.xlsx';
        a.click();
        URL.revokeObjectURL(url);
        setLoading(false)
      });
    }
    catch (error) {
      console.error(error);
      setLoading(false)
    }
  };

  const renderModalContent = () => {
    return (
      <>
        {targetRows.length > 0 && (
          <>
            <DataGridContainer>
              <DataGrid
                disableSelectionOnClick={true}
                checkboxSelection={true}
                rows={targetRows}
                columns={getGridColumns()}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                  setSelectedRowIds(newRowSelectionModel);
                }}
                rowSelectionModel={selectedRowIds}
                density="compact"
                autoPageSize
                getRowClassName={getRowClassName}
                components={{
                  Toolbar: CustomToolbar,
                }}
                pageSizeOptions={[10]}
              />
            </DataGridContainer>
            <NoteText variant="body2">
              Note: If selected, only the selected rows will be uploaded
            </NoteText>
          </>
        )}
        <InputFieldContainer>
          <Button variant="contained" sx={{
            background: "primary",
            borderColor: "#003974",
            height: "50px",
            // borderRadius: "40px",
            padding: "5px 10px",
            marginRight: "20px",
          }} color="primary" onClick={handleDownload}>Download Template</Button>
          <input
            key={fileKey}
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={handleFileUpload}
            style={{ display: "none" }}
            ref={fileInputRef}
          />
          <Button
            variant="contained"
            sx={{
              background: "primary",
              borderColor: "#003974",
              height: "50px",
              padding: "5px 10px",
              marginRight: "20px",
            }}
            onClick={handleButtonClick}
          >
            Select File
          </Button>
          {selectedFile && (
            <Button
              variant="contained"
              color="success"
              sx={{
                height: "50px",
                padding: "5px 10px",
                marginRight: "20px",
              }}
              onClick={handleUpload}
              disabled={loading}
            >
              {loading ? "Uploading..." : "Upload"}
            </Button>
          )}
        </InputFieldContainer>
      </>
    );
  };
  const handleClose = () => {
    onClose()
    // fetchData()
  }
  return (
    <StyledDialog
      disableEnforceFocus
      maxWidth="md"
      fullWidth={true}
      open={showModal}
    >
      <StyledDialogContent>
        <ModalHeaderContainer>
          <Typography variant="h5">Add Specimen Product Bulk</Typography>
          <IconButton disabled={loading} onClick={() => handleClose()}>
            <CloseOutlined />
          </IconButton>
        </ModalHeaderContainer>
        {loading && <OpaqueLoading />}
        {renderModalContent()}
      </StyledDialogContent>
    </StyledDialog>
  );
};
export default BulkUploadSpecimenByAdmin;

